import styled from 'styled-components';

export const Wrapper = styled.label`
  align-items: center;
  display: inline-block;
  position: relative;
`;

export const Button = styled.button`
  font-weight: inherit;
`;

export const TextInput = styled.input`
  border: 0;
  height: 24px;
  left: 0;
  margin: 0;
  opacity: 0;
  outline: none;
  position: absolute;
  padding: 0;
  top: 0;
  width: 24px;
  z-index: -1;
`;
